<template>
  <ScrollView
    class="DashScrollContainer"
    :refreshing="refreshing"
    @onRefresh="onRefresh"
    :empty="data.length===0"
  >
    <div
      v-for="(item, i) of data"
      :key="`${item.titulo}_${i}`"
      style="flex: 1"
    >
      <span class="TextSubTitle">{{ item.titulo }}</span>
      <NumericalIndicator :data="item.data" />
    </div>
    <template slot="Empty">
      <slot name="Empty" />
    </template>
  </ScrollView>
</template>

<script>
import NumericalIndicator from './NumericalIndicator'
export default {
  name: "ListNumericalIndicator",
  components: {
    NumericalIndicator,
  },
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: [Array, Object],
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.TextSubTitle {
  font-weight: bold;
  font-style: 29px;
  color: #000;
}
</style>
